(function () {
  var contextualPriceMaxCache = {};
  var contextualPriceMaxPendingRoots = {};
  var contextualPriceMaxRequests = {};

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setFieldValue(input, value) {
    var formatted;

    if (!input) return;
    formatted = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
    input.value = formatted;
    input.setAttribute('value', formatted);
  }

  function clearFieldValue(input) {
    if (!input) return;
    input.value = '';
    input.removeAttribute('value');
  }

  function getFormattedRangeValue(value) {
    return Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function isAtRangeStart(value, min) {
    return value <= min || Math.abs(value - min) < 0.0001;
  }

  function isAtRangeEnd(value, max) {
    return value >= max || Math.abs(value - max) < 0.0001;
  }

  function setRangeFieldValues(root, parts, lower, upper) {
    var isPriceRange = root.hasAttribute('data-kk-price-range');

    if (!isPriceRange) {
      setFieldValue(parts.minInput, lower);
      setFieldValue(parts.maxInput, upper);
      return;
    }

    if (parts.minInput) {
      if (isAtRangeStart(lower, parts.min)) {
        clearFieldValue(parts.minInput);
      } else {
        setFieldValue(parts.minInput, lower);
      }
    }

    if (parts.maxInput) {
      if (isAtRangeEnd(upper, parts.max)) {
        clearFieldValue(parts.maxInput);
      } else {
        setFieldValue(parts.maxInput, upper);
      }
    }
  }

  function getRangeParts(root) {
    return {
      min: toNumber(root.dataset.kkRangeMin, 0),
      max: toNumber(root.dataset.kkRangeMax, 0),
      lower: root.querySelector('[data-kk-range-lower]'),
      upper: root.querySelector('[data-kk-range-upper]'),
      minInput: root.querySelector('[data-kk-range-min-input]'),
      maxInput: root.querySelector('[data-kk-range-max-input]')
    };
  }

  function getPriceParamNames(root) {
    var parts = getRangeParts(root);

    return {
      min: parts.minInput && parts.minInput.name ? parts.minInput.name : 'filter.v.price.gte',
      max: parts.maxInput && parts.maxInput.name ? parts.maxInput.name : 'filter.v.price.lte'
    };
  }

  function buildContextualPriceMaxUrl(root) {
    var form = root.closest('[data-filter-form]');
    var paramsToRefresh = {};
    var priceParams = getPriceParamNames(root);
    var url;

    try {
      url = new URL(window.location.href);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('page');
    url.searchParams.delete(priceParams.min);
    url.searchParams.delete(priceParams.max);

    if (form) {
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field && field.name) {
          paramsToRefresh[field.name] = true;
        }
      });

      Object.keys(paramsToRefresh).forEach(function (name) {
        url.searchParams.delete(name);
      });

      new URLSearchParams(new FormData(form)).forEach(function (value, name) {
        if (name === priceParams.min || name === priceParams.max || String(value || '') === '') {
          return;
        }

        url.searchParams.append(name, value);
      });
    }

    url.searchParams.set('sort_by', 'price-descending');

    return url.pathname + url.search;
  }

  function buildContextualPriceMaxUrlFromUrl(sourceUrl) {
    var url;

    try {
      url = new URL(sourceUrl || window.location.href, window.location.origin);
    } catch (error) {
      return '';
    }

    url.searchParams.delete('page');
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');
    url.searchParams.set('sort_by', 'price-descending');

    return url.pathname + url.search;
  }

  function getExplicitPriceSelection(root, sourceUrl) {
    var priceParams = getPriceParamNames(root);
    var url;

    try {
      url = new URL(window.location.href, window.location.origin);
    } catch (error) {
      url = null;
    }

    if (!url) {
      return {
        min: false,
        max: false
      };
    }

    return {
      min: String(url.searchParams.get(priceParams.min) || '') !== '',
      max: String(url.searchParams.get(priceParams.max) || '') !== ''
    };
  }

  function readMaxProductPriceFromScope(scope) {
    var maxPrice = 0;

    if (!scope || !scope.querySelectorAll) {
      return 0;
    }

    scope.querySelectorAll('script[data-product-data]').forEach(function (script) {
      var product;
      var price;

      try {
        product = JSON.parse(script.textContent || '{}');
      } catch (error) {
        product = {};
      }

      price = toNumber(product.price_max || product.price || 0, 0);

      if (price > maxPrice) {
        maxPrice = price;
      }
    });

    return maxPrice;
  }

  function readMinProductPriceFromScope(scope) {
    var minPrice = null;

    if (!scope || !scope.querySelectorAll) {
      return 0;
    }

    scope.querySelectorAll('script[data-product-data]').forEach(function (script) {
      var product;
      var price;

      try {
        product = JSON.parse(script.textContent || '{}');
      } catch (error) {
        product = {};
      }

      price = toNumber(product.price || 0, 0);

      if (price <= 0) return;
      if (minPrice === null || price < minPrice) {
        minPrice = price;
      }
    });

    return minPrice === null ? 0 : minPrice;
  }

  function readMaxProductPriceFromHtml(markup) {
    var doc = new DOMParser().parseFromString(markup, 'text/html');

    return readMaxProductPriceFromScope(doc);
  }

  function setMaxAttribute(input, value) {
    if (input) {
      input.setAttribute('max', getFormattedRangeValue(value));
    }
  }

  function formatNumberForPriceTag(value, sample) {
    var numericValue = Math.round(toNumber(value, 0) * 100) / 100;
    var sampleText = String(sample || '');
    var firstDigit = sampleText.search(/\d/);
    var lastDigit = Math.max(
      sampleText.lastIndexOf('0'),
      sampleText.lastIndexOf('1'),
      sampleText.lastIndexOf('2'),
      sampleText.lastIndexOf('3'),
      sampleText.lastIndexOf('4'),
      sampleText.lastIndexOf('5'),
      sampleText.lastIndexOf('6'),
      sampleText.lastIndexOf('7'),
      sampleText.lastIndexOf('8'),
      sampleText.lastIndexOf('9')
    );
    var prefix = firstDigit > -1 ? sampleText.slice(0, firstDigit) : '';
    var suffix = lastDigit > -1 ? sampleText.slice(lastDigit + 1) : '';
    var decimalSeparator = sampleText.lastIndexOf(',') > sampleText.lastIndexOf('.') ? ',' : '.';
    var thousandsSeparator = decimalSeparator === ',' ? '.' : ',';
    var fixed = numericValue.toFixed(2).split('.');
    var integerPart = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

    return prefix + integerPart + decimalSeparator + fixed[1] + suffix;
  }

  function updateActivePriceFilterTags(root, contextualMax, sourceUrl) {
    var explicitPriceSelection = getExplicitPriceSelection(root, sourceUrl);
    var doc = root && root.ownerDocument ? root.ownerDocument : document;

    if (explicitPriceSelection.max) {
      return;
    }

    doc.querySelectorAll('[data-kk-active-price-filter]').forEach(function (link) {
      var text = link.querySelector('.filter-text');
      var parts;
      var maxText;

      if (!text || link.getAttribute('data-kk-active-price-has-max') === 'true') {
        return;
      }

      parts = text.textContent.split(/\s+-\s+/);

      if (parts.length < 2) {
        return;
      }

      maxText = formatNumberForPriceTag(contextualMax, parts[1]);
      text.textContent = parts[0] + ' - ' + maxText;
    });
  }

  function applyContextualPriceMax(root, maxPriceCents, sourceUrl) {
    var contextualMax = Math.ceil(toNumber(maxPriceCents, 0) / 100);
    var parts;
    var oldMax;
    var currentLower;
    var currentUpper;
    var currentMaxInput;
    var explicitPriceSelection;
    var wasAtOldMax;
    var bounds;

    if (!root || !root.hasAttribute('data-kk-price-range') || contextualMax <= 0) {
      return;
    }

    parts = getRangeParts(root);
    oldMax = parts.max;
    contextualMax = Math.max(contextualMax, parts.min);

    currentLower = toNumber(parts.lower && parts.lower.value, parts.min);
    currentUpper = toNumber(parts.upper && parts.upper.value, oldMax);
    currentMaxInput = parts.maxInput && parts.maxInput.value !== '' ?
      toNumber(parts.maxInput.value, null) :
      null;
    explicitPriceSelection = getExplicitPriceSelection(root, sourceUrl);
    wasAtOldMax = !explicitPriceSelection.max ||
      currentMaxInput === null ||
      isAtRangeEnd(currentUpper, oldMax) ||
      isAtRangeEnd(currentMaxInput, oldMax);

    root.dataset.kkRangeMax = getFormattedRangeValue(contextualMax);

    setMaxAttribute(parts.minInput, contextualMax);
    setMaxAttribute(parts.maxInput, contextualMax);
    setMaxAttribute(parts.lower, contextualMax);
    setMaxAttribute(parts.upper, contextualMax);

    if (parts.maxInput) {
      parts.maxInput.placeholder = getFormattedRangeValue(contextualMax);
      parts.maxInput.setAttribute('placeholder', getFormattedRangeValue(contextualMax));
      if (wasAtOldMax) {
        clearFieldValue(parts.maxInput);
      } else if (currentMaxInput !== null && currentMaxInput > contextualMax) {
        setFieldValue(parts.maxInput, contextualMax);
      }
    }

    if (!explicitPriceSelection.min) {
      clearFieldValue(parts.minInput);
      if (parts.lower) {
        setFieldValue(parts.lower, parts.min);
      }
    } else if (parts.minInput && toNumber(parts.minInput.value, parts.min) > contextualMax) {
      setFieldValue(parts.minInput, contextualMax);
    }

    if (parts.lower && currentLower > contextualMax) {
      setFieldValue(parts.lower, contextualMax);
    }

    if (parts.upper && (wasAtOldMax || currentUpper > contextualMax)) {
      setFieldValue(parts.upper, contextualMax);
    }

    bounds = root.querySelector('.kk-range-filter__bounds span:last-child');
    if (bounds) {
      bounds.textContent = getFormattedRangeValue(contextualMax);
    }

    updateActivePriceFilterTags(root, contextualMax, sourceUrl);
    paintRange(root);
  }

  function flushContextualPriceMax(url, maxPriceCents) {
    var roots = contextualPriceMaxPendingRoots[url] || [];

    roots.forEach(function (root) {
      if (document.documentElement.contains(root)) {
        applyContextualPriceMax(root, maxPriceCents, url);
      }
    });

    contextualPriceMaxPendingRoots[url] = [];
  }

  function clearContextualPriceMaxPending(url) {
    contextualPriceMaxPendingRoots[url] = [];
  }

  function requestContextualPriceMax(url) {
    if (!url) {
      return Promise.resolve(0);
    }

    if (contextualPriceMaxCache[url]) {
      return Promise.resolve(contextualPriceMaxCache[url]);
    }

    if (contextualPriceMaxRequests[url]) {
      return contextualPriceMaxRequests[url];
    }

    contextualPriceMaxRequests[url] = fetch(url, {
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Contextual price max request failed');
      }

      return response.text();
    }).then(function (markup) {
      var maxPriceCents = readMaxProductPriceFromHtml(markup);

      if (maxPriceCents > 0) {
        contextualPriceMaxCache[url] = maxPriceCents;
      }

      return maxPriceCents;
    }).catch(function () {
      return 0;
    }).then(function (maxPriceCents) {
      delete contextualPriceMaxRequests[url];
      return maxPriceCents;
    });

    return contextualPriceMaxRequests[url];
  }

  function primeContextualPriceMaxForUrl(sourceUrl) {
    return requestContextualPriceMax(buildContextualPriceMaxUrlFromUrl(sourceUrl));
  }

  function applyContextualPriceMaxToScope(scope, maxPriceCents, sourceUrl) {
    if (!scope || !scope.querySelectorAll || !maxPriceCents) {
      return;
    }

    scope.querySelectorAll('[data-kk-price-range]').forEach(function (root) {
      applyContextualPriceMax(root, maxPriceCents, sourceUrl);
    });
  }

  function updateContextualPriceMax(root) {
    var url;
    var visibleMaxPriceCents;

    if (!root || !root.hasAttribute('data-kk-price-range')) {
      return;
    }

    url = buildContextualPriceMaxUrl(root);

    if (!url) {
      return;
    }

    visibleMaxPriceCents = readMaxProductPriceFromScope(document);
    if (visibleMaxPriceCents > getRangeParts(root).max * 100) {
      applyContextualPriceMax(root, visibleMaxPriceCents, url);
    }

    if (contextualPriceMaxCache[url]) {
      applyContextualPriceMax(root, contextualPriceMaxCache[url], url);
      return;
    }

    if (!contextualPriceMaxPendingRoots[url]) {
      contextualPriceMaxPendingRoots[url] = [];
    }

    contextualPriceMaxPendingRoots[url].push(root);

    requestContextualPriceMax(url).then(function (maxPriceCents) {
      if (maxPriceCents > 0) {
        flushContextualPriceMax(url, maxPriceCents);
      } else {
        clearContextualPriceMaxPending(url);
      }
    });
  }

  function readRange(root) {
    var parts = getRangeParts(root);
    var lower = toNumber(parts.lower && parts.lower.value, parts.min);
    var upper = toNumber(parts.upper && parts.upper.value, parts.max);

    lower = clamp(lower, parts.min, parts.max);
    upper = clamp(upper, parts.min, parts.max);

    if (lower > upper) {
      if (document.activeElement === parts.lower || document.activeElement === parts.minInput) {
        upper = lower;
      } else {
        lower = upper;
      }
    }

    return {
      parts: parts,
      lower: lower,
      upper: upper
    };
  }

  function paintRange(root) {
    var range = readRange(root);
    var parts = range.parts;

    if (parts.lower) setFieldValue(parts.lower, range.lower);
    if (parts.upper) setFieldValue(parts.upper, range.upper);
    setRangeFieldValues(root, parts, range.lower, range.upper);
    updateRangeTooltips(root);
  }

  function updateRangeTooltips(root) {
    if (!root) return;
    var slider = root.querySelector('[data-kk-range-track]') || root.querySelector('.kk-range-filter__slider');
    if (!slider) return;

    var prefix = slider.getAttribute('data-kk-tooltip-prefix') || '';
    var lower = slider.querySelector('[data-kk-range-lower]');
    var upper = slider.querySelector('[data-kk-range-upper]');
    var tooltipLower = slider.querySelector('[data-kk-range-tooltip="lower"]');
    var tooltipUpper = slider.querySelector('[data-kk-range-tooltip="upper"]');

    function update(input, tooltip) {
      if (!input || !tooltip) return;
      var inputMin = toNumber(input.min, 0);
      var inputMax = toNumber(input.max, 100);
      var value = toNumber(input.value, inputMin);
      var span = inputMax - inputMin;
      var percent = span > 0 ? ((value - inputMin) / span * 100) : 0;
      var thumbHalf = 13;
      var offset = thumbHalf * (1 - percent / 50);
      tooltip.style.left = 'calc(' + percent + '% + ' + offset.toFixed(2) + 'px)';
      tooltip.textContent = prefix ? prefix + value : String(value);
    }

    update(lower, tooltipLower);
    update(upper, tooltipUpper);
  }

  function syncSliderFromFields(root) {
    var parts = getRangeParts(root);
    var lower = toNumber(parts.minInput && parts.minInput.value, parts.min);
    var upper = toNumber(parts.maxInput && parts.maxInput.value, parts.max);

    lower = clamp(lower, parts.min, parts.max);
    upper = clamp(upper, parts.min, parts.max);

    if (lower > upper) {
      if (document.activeElement === parts.minInput) {
        upper = lower;
      } else {
        lower = upper;
      }
    }

    if (parts.lower) setFieldValue(parts.lower, lower);
    if (parts.upper) setFieldValue(parts.upper, upper);
    paintRange(root);
  }

  function dispatchNativeChange(input) {
    if (!input) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function commitNativeRange(root) {
    var range = readRange(root);
    var options = root.querySelectorAll('[data-kk-native-range-option]');
    var fullRange = range.lower <= range.parts.min && range.upper >= range.parts.max;
    var changed = false;
    var eventTarget = null;

    options.forEach(function (option) {
      var value = toNumber(option.dataset.kkRangeValue, range.parts.min);
      var shouldCheck = !fullRange && value >= range.lower && value <= range.upper && !option.disabled;

      if (option.checked !== shouldCheck) {
        option.checked = shouldCheck;
        changed = true;
        if (!eventTarget) eventTarget = option;
      }
    });

    paintRange(root);

    if (changed) {
      dispatchNativeChange(eventTarget || options[0]);
    }
  }

  function commitPriceRange(root) {
    var range = readRange(root);
    var minInput = range.parts.minInput;
    var maxInput = range.parts.maxInput;
    var changeTarget;

    setRangeFieldValues(root, range.parts, range.lower, range.upper);
    changeTarget = minInput && minInput.value !== '' ? minInput : maxInput || minInput;
    dispatchNativeChange(changeTarget);
  }

  function handleRangeInput(event) {
    var target = event.target;
    var root = target.closest('[data-kk-native-range], [data-kk-price-range]');

    if (!root) return;

    if (target.matches('[data-kk-range-min-input], [data-kk-range-max-input]')) {
      syncSliderFromFields(root);
    } else {
      paintRange(root);
    }
  }

  function handleRangeChange(event) {
    var target = event.target;
    var root = target.closest('[data-kk-native-range], [data-kk-price-range]');

    if (!root) return;

    if (target.matches('[data-kk-range-min-input], [data-kk-range-max-input]')) {
      syncSliderFromFields(root);
    } else {
      paintRange(root);
    }

    if (root.hasAttribute('data-kk-native-range')) {
      commitNativeRange(root);
    } else if (target.matches('[data-kk-range-lower], [data-kk-range-upper]')) {
      commitPriceRange(root);
    }
  }

  function handleFacetSearch(event) {
    var input = event.target.closest('[data-kk-filter-search]');
    if (!input) return;

    var facet = input.closest('[data-kk-facet]');
    var term = input.value.trim().toLowerCase();
    var options = facet ? facet.querySelectorAll('[data-kk-filter-option]') : [];
    var toggle = facet ? facet.querySelector('[data-filter-toggle]') : null;
    var filterGroup = facet ? facet.querySelector('[data-kk-filter-list]') : null;
    var expanded = toggle && toggle.getAttribute('data-filter-toggle') === 'true';

    options.forEach(function (option) {
      var text = (option.getAttribute('data-kk-filter-search-text') || option.textContent || '').trim().toLowerCase();
      var matches = !term || text.indexOf(term) !== -1;

      option.hidden = !matches;
      option.classList.toggle('kk-filter-option--search-hidden', !matches);

      if (term) {
        option.classList.remove('filter-item--hidden');
      } else if (option.hasAttribute('data-hidden-default')) {
        option.classList.add('filter-item--hidden');
      }
    });

    if (toggle) {
      var toggleItem = toggle.closest('.filter-item');

      if (toggleItem) {
        toggleItem.hidden = Boolean(term);
        toggleItem.classList.toggle('kk-filter-option--search-hidden', Boolean(term));
      }
    }

    if (filterGroup) {
      filterGroup.classList.toggle('kk-facet__list--expanded', Boolean(term) || Boolean(expanded));
    }
  }

  function shouldPrimeContextualPriceMax(target) {
    return Boolean(
      target &&
      !target.closest('[data-kk-price-range]') &&
      target.closest('[data-filter-form]') &&
      target.closest(
        '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
      )
    );
  }

  function primeContextualPriceMax(target) {
    var form = target && target.closest('[data-filter-form]');
    var priceRange = form && form.querySelector('[data-kk-price-range]');

    if (!shouldPrimeContextualPriceMax(target) || !priceRange) {
      return;
    }

    updateContextualPriceMax(priceRange);
  }

  function initializeRanges(root) {
    root.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (range) {
      if (range.hasAttribute('data-kk-price-range')) {
        updateContextualPriceMax(range);
      }

      paintRange(range);
    });
    syncStaticSearchRangeFacets(root);
  }

  function syncStaticSearchRangeFacets(root) {
    var ranges = [];

    if (root.matches && root.matches('[data-kk-search-sidebar-filters] [data-kk-native-range]')) {
      ranges.push(root);
    }

    root.querySelectorAll('[data-kk-search-sidebar-filters] [data-kk-native-range]').forEach(function (range) {
      ranges.push(range);
    });

    ranges.forEach(function (range) {
      var min = toNumber(range.dataset.kkRangeMin, null);
      var max = toNumber(range.dataset.kkRangeMax, null);
      var facet = range.closest('[data-kk-facet]');

      if (!facet || min === null || max === null) return;

      facet.hidden = min === max;
    });
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]')) {
      handleRangeInput(event);
    }

    handleFacetSearch(event);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]')) {
      handleRangeChange(event);
    }

    primeContextualPriceMax(event.target);
  });

  function handleFilterToggleClick(event) {
    var toggle = event.target.closest && event.target.closest('[data-filter-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    var siblingsVisible = toggle.getAttribute('data-filter-toggle') === 'true';
    var filterGroup = toggle.closest('.filter-group, [data-filter-group], ul');
    var hiddenFilters = filterGroup ? filterGroup.querySelectorAll('[data-hidden-default]') : [];
    var seeMoreText =
      toggle.getAttribute('data-kk-see-more-text') ||
      (window.Theme && window.Theme.language && window.Theme.language.see_more) ||
      'See more';
    var seeLessText =
      toggle.getAttribute('data-kk-see-less-text') ||
      (window.Theme && window.Theme.language && window.Theme.language.see_less) ||
      'See less';

    hiddenFilters.forEach(function (filter) {
      if (siblingsVisible) {
        filter.classList.add('filter-item--hidden');
      } else {
        filter.classList.remove('filter-item--hidden');
      }
    });

    if (filterGroup) {
      filterGroup.classList.toggle('kk-facet__list--expanded', !siblingsVisible);
    }

    toggle.textContent = siblingsVisible ? seeMoreText : seeLessText;
    toggle.setAttribute('data-filter-toggle', siblingsVisible ? 'false' : 'true');
  }

  document.addEventListener('click', handleFilterToggleClick, true);

  window.kkContextualPriceMax = {
    applyToScope: applyContextualPriceMaxToScope,
    primeForUrl: primeContextualPriceMaxForUrl
  };

  function syncPriceSliderFromUrl(root) {
    if (!root || !root.hasAttribute || !root.hasAttribute('data-kk-price-range')) return;

    var parts = getRangeParts(root);
    var params = new URLSearchParams(window.location.search);
    var gteName = (parts.minInput && parts.minInput.name) || 'filter.v.price.gte';
    var lteName = (parts.maxInput && parts.maxInput.name) || 'filter.v.price.lte';
    var gte = params.get(gteName);
    var lte = params.get(lteName);
    var lowerVal = (gte !== null && gte !== '') ? clamp(toNumber(gte, parts.min), parts.min, parts.max) : parts.min;
    var upperVal = (lte !== null && lte !== '') ? clamp(toNumber(lte, parts.max), parts.min, parts.max) : parts.max;

    if (parts.lower) setFieldValue(parts.lower, lowerVal);
    if (parts.upper) setFieldValue(parts.upper, upperVal);

    if (parts.minInput) {
      if (gte === null || gte === '') {
        clearFieldValue(parts.minInput);
      } else {
        setFieldValue(parts.minInput, lowerVal);
      }
    }

    if (parts.maxInput) {
      if (lte === null || lte === '') {
        clearFieldValue(parts.maxInput);
      } else {
        setFieldValue(parts.maxInput, upperVal);
      }
    }
  }

  function syncAllPriceSlidersFromUrl() {
    document.querySelectorAll('[data-kk-price-range]').forEach(syncPriceSliderFromUrl);
  }

  function syncPriceRangeMinFromVisibleProducts() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('filter.v.price.gte') || params.get('filter.v.price.lte')) {
      return;
    }

    var minCents = readMinProductPriceFromScope(document);
    var minEuros = Math.floor(toNumber(minCents, 0) / 100);

    if (minEuros <= 0) return;

    document.querySelectorAll('[data-kk-price-range]').forEach(function (root) {
      var parts = getRangeParts(root);
      var maxValue = parts.max;
      var clampedMin = Math.max(0, Math.min(minEuros, maxValue));
      var formatted = getFormattedRangeValue(clampedMin);

      root.dataset.kkRangeMin = formatted;

      if (parts.minInput) {
        parts.minInput.setAttribute('min', formatted);
        parts.minInput.placeholder = formatted;
        parts.minInput.setAttribute('placeholder', formatted);
      }
      if (parts.maxInput) parts.maxInput.setAttribute('min', formatted);
      if (parts.lower) parts.lower.setAttribute('min', formatted);
      if (parts.upper) parts.upper.setAttribute('min', formatted);

      var boundsFirst = root.querySelector('.kk-range-filter__bounds span:first-child');
      if (boundsFirst) {
        boundsFirst.textContent = formatted;
      }

      var params = new URLSearchParams(window.location.search);
      var gteName = (parts.minInput && parts.minInput.name) || 'filter.v.price.gte';
      var gte = params.get(gteName);
      if ((gte === null || gte === '') && parts.lower) {
        setFieldValue(parts.lower, clampedMin);
      }
    });
  }

  function syncAfterUrlOrDomChange() {
    syncAllPriceSlidersFromUrl();
    syncPriceRangeMinFromVisibleProducts();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeRanges(document);
    syncPriceRangeMinFromVisibleProducts();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            initializeRanges(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.querySelectorAll('[data-results-container]').forEach(function (container) {
      var debounceTimer = null;
      new MutationObserver(function () {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(syncAfterUrlOrDomChange, 50);
      }).observe(container, { childList: true });
    });

    document.querySelectorAll('[data-modal-container]').forEach(function (modalContainer) {
      var wasOpenForFilters = modalContainer.classList.contains('modal--productgrid-filters');
      new MutationObserver(function () {
        var isOpenForFilters = modalContainer.classList.contains('modal--productgrid-filters');
        if (isOpenForFilters && !wasOpenForFilters) {
          window.setTimeout(syncAfterUrlOrDomChange, 50);
        }
        wasOpenForFilters = isOpenForFilters;
      }).observe(modalContainer, { attributes: true, attributeFilter: ['class'] });
    });

    var originalPushState = window.history.pushState;
    var pushStateTimer = null;
    window.history.pushState = function () {
      var result = originalPushState.apply(this, arguments);
      window.clearTimeout(pushStateTimer);
      pushStateTimer = window.setTimeout(syncAfterUrlOrDomChange, 80);
      return result;
    };

    window.addEventListener('popstate', function () {
      window.setTimeout(syncAfterUrlOrDomChange, 80);
    });
  });
}());

(function () {
  var suppressThemeScrollUntil = 0;

  function isHtmlBodyCollection(collection) {
    var matches = false;

    collection.each(function () {
      var tagName = this.tagName ? this.tagName.toLowerCase() : '';

      if (tagName === 'html' || tagName === 'body') {
        matches = true;
      }
    });

    return matches;
  }

  function patchJQueryAnimate(jQueryInstance) {
    if (!jQueryInstance || !jQueryInstance.fn || jQueryInstance.fn.kkFilterScrollPatched) {
      return;
    }

    var originalAnimate = jQueryInstance.fn.animate;

    jQueryInstance.fn.animate = function (properties) {
      var isThemeScrollToTop = properties &&
        Object.prototype.hasOwnProperty.call(properties, 'scrollTop') &&
        isHtmlBodyCollection(this);

      if (isThemeScrollToTop && Date.now() < suppressThemeScrollUntil) {
        return this;
      }

      return originalAnimate.apply(this, arguments);
    };

    jQueryInstance.fn.kkFilterScrollPatched = true;
  }

  function patchAvailableJQuery() {
    patchJQueryAnimate(window.jQuery);
    patchJQueryAnimate(window.$);
  }

  function suppressThemeScrollToTop() {
    suppressThemeScrollUntil = Date.now() + 4000;
    patchAvailableJQuery();
  }

  function isFilterChangeTarget(target) {
    return Boolean(target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    ));
  }

  document.addEventListener('change', function (event) {
    if (isFilterChangeTarget(event.target)) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab' && event.target.closest('[data-filter-range]')) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-filter-remove]')) {
      suppressThemeScrollToTop();
    }
  }, true);

  document.addEventListener('DOMContentLoaded', patchAvailableJQuery);
}());

(function () {
  var updateTimer = null;

  function updateSortbyChevron(wrapper) {
    var select = wrapper ? wrapper.querySelector('[data-productgrid-trigger-sort]') : null;
    var measure = wrapper ? wrapper.querySelector('[data-kk-sortby-measure]') : null;
    var selectedText = '';
    var width = 0;

    if (!select || !measure) {
      return;
    }

    if (select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
      selectedText = select.options[select.selectedIndex].text.trim();
    }

    measure.textContent = selectedText;
    width = measure.getBoundingClientRect().width;
    wrapper.style.setProperty('--kk-sortby-selected-width', Math.ceil(width) + 'px');
  }

  function updateAllSortbyChevrons() {
    document.querySelectorAll('.utils-sortby-select').forEach(updateSortbyChevron);
  }

  function queueUpdateAllSortbyChevrons() {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateAllSortbyChevrons, 30);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-productgrid-trigger-sort]');

    if (select) {
      updateSortbyChevron(select.closest('.utils-sortby-select'));
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllSortbyChevrons);
  } else {
    updateAllSortbyChevrons();
  }

  if (window.MutationObserver) {
    new MutationObserver(queueUpdateAllSortbyChevrons).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
}());

(function () {
  var pendingSnapshot = null;
  var replayingPendingSnapshot = false;
  var pendingFlushTimer = null;

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getFilterForm() {
    var modal = document.querySelector('[data-modal-container]');
    var modalForm = modal && modal.querySelector('[data-filter-form]');

    if (modalForm && document.body.classList.contains('modal-visible')) {
      return modalForm;
    }

    return document.querySelector('[data-filter-form]');
  }

  function getResultsContainer() {
    return document.querySelector('[data-results-container]');
  }

  function getSidebarContainer() {
    return document.querySelector('[data-product-grid-sidebar]');
  }

  function isFilterProcessing() {
    var results = getResultsContainer();
    var sidebar = getSidebarContainer();

    return Boolean(
      results && results.classList.contains('processing--filter') ||
      sidebar && sidebar.classList.contains('processing--filter')
    );
  }

  function setFilterProcessing(isProcessing) {
    var sidebar = getSidebarContainer();

    if (sidebar) {
      sidebar.classList.toggle('processing--filter', isProcessing);
    }

    syncFilterLoadingIcons();
  }

  function isMobileFilterSpinnerUi() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function clearFilterLoadingIconPosition(icon) {
    if (!icon) {
      return;
    }

    icon.style.removeProperty('position');
    icon.style.removeProperty('left');
    icon.style.removeProperty('top');
    icon.style.removeProperty('right');
    icon.style.removeProperty('bottom');
    icon.style.removeProperty('margin-left');
  }

  function getPrimaryFilterLoadingIcon(container) {
    var children;
    var index;

    if (!container || !container.children) {
      return null;
    }

    children = container.children;

    for (index = 0; index < children.length; index += 1) {
      if (
        children[index].classList &&
        children[index].classList.contains('kk-primary-grid-loader')
      ) {
        return children[index];
      }
    }

    return null;
  }

  function positionFilterLoadingIcon(container) {
    var icon = getPrimaryFilterLoadingIcon(container);
    var viewport = window.visualViewport;
    var centerLeft;
    var centerTop;
    var width;
    var height;

    if (!icon) {
      return;
    }

    if (!isMobileFilterSpinnerUi()) {
      clearFilterLoadingIconPosition(icon);
      return;
    }

    centerLeft = viewport ? viewport.offsetLeft + viewport.width / 2 : window.innerWidth / 2;
    centerTop = viewport ? viewport.offsetTop + viewport.height / 2 : window.innerHeight / 2;
    width = icon.getBoundingClientRect().width || icon.offsetWidth || 64;
    height = icon.getBoundingClientRect().height || icon.offsetHeight || 64;

    icon.style.setProperty('position', 'fixed', 'important');
    icon.style.setProperty('left', centerLeft - width / 2 + 'px', 'important');
    icon.style.setProperty('top', centerTop - height / 2 + 'px', 'important');
    icon.style.setProperty('right', 'auto', 'important');
    icon.style.setProperty('bottom', 'auto', 'important');
    icon.style.setProperty('margin-left', '0', 'important');
  }

  function syncFilterLoadingIcons() {
    return;
  }

  function getFieldKey(field) {
    return field.name + '\u0000' + (field.value || '');
  }

  function getRangeKey(root) {
    var option = root.querySelector('[data-kk-native-range-option]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    if (option && option.name) {
      return option.name;
    }

    if (minInput && maxInput && minInput.name && maxInput.name) {
      return minInput.name + '|' + maxInput.name;
    }

    return '';
  }

  function getFormQuery(form) {
    return form ? new URLSearchParams(new FormData(form)).toString() : '';
  }

  function snapshotRange(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');
    var rangeLower = toNumber(lower && lower.value, toNumber(minInput && minInput.value, min));
    var rangeUpper = toNumber(upper && upper.value, toNumber(maxInput && maxInput.value, max));

    rangeLower = clamp(rangeLower, min, max);
    rangeUpper = clamp(rangeUpper, min, max);

    if (rangeLower > rangeUpper) {
      rangeUpper = rangeLower;
    }

    return {
      key: getRangeKey(root),
      lower: rangeLower,
      upper: rangeUpper
    };
  }

  function snapshotFilterState() {
    var form = getFilterForm();
    var checkboxes = {};
    var fields = {};
    var ranges = [];

    if (!form) {
      return null;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        checkboxes[getFieldKey(field)] = field.checked;
      } else {
        fields[field.name] = field.value;
      }
    });

    form.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (root) {
      var range = snapshotRange(root);

      if (range.key) {
        ranges.push(range);
      }
    });

    return {
      checkboxes: checkboxes,
      fields: fields,
      ranges: ranges,
      query: getFormQuery(form)
    };
  }

  function setFieldValue(input, value) {
    if (!input) return;
    input.value = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function isAtRangeStart(value, min) {
    return value <= min || Math.abs(value - min) < 0.0001;
  }

  function isAtRangeEnd(value, max) {
    return value >= max || Math.abs(value - max) < 0.0001;
  }

  function setRangeFieldValues(root, minInput, maxInput, lower, upper, min, max) {
    var isPriceRange = root.hasAttribute('data-kk-price-range');

    if (!isPriceRange) {
      setFieldValue(minInput, lower);
      setFieldValue(maxInput, upper);
      return;
    }

    if (minInput) {
      if (isAtRangeStart(lower, min)) {
        minInput.value = '';
      } else {
        setFieldValue(minInput, lower);
      }
    }

    if (maxInput) {
      if (isAtRangeEnd(upper, max)) {
        maxInput.value = '';
      } else {
        setFieldValue(maxInput, upper);
      }
    }
  }

  function applyRangeState(root, state) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = clamp(toNumber(state.lower, min), min, max);
    var upper = clamp(toNumber(state.upper, max), min, max);
    var lowerSlider = root.querySelector('[data-kk-range-lower]');
    var upperSlider = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    if (lower > upper) {
      upper = lower;
    }

    if (lowerSlider) lowerSlider.value = lower;
    if (upperSlider) upperSlider.value = upper;
    setRangeFieldValues(root, minInput, maxInput, lower, upper, min, max);

    if (root.hasAttribute('data-kk-native-range')) {
      var fullRange = lower <= min && upper >= max;

      root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
        var value = toNumber(option.dataset.kkRangeValue, min);
        option.checked = !fullRange && value >= lower && value <= upper && !option.disabled;
      });
    }
  }

  function applySnapshot(snapshot) {
    var form = getFilterForm();
    var rangesByKey = {};

    if (!form || !snapshot) {
      return false;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = Boolean(snapshot.checkboxes[getFieldKey(field)]);
      } else if (Object.prototype.hasOwnProperty.call(snapshot.fields, field.name)) {
        field.value = snapshot.fields[field.name];
      }
    });

    snapshot.ranges.forEach(function (range) {
      rangesByKey[range.key] = range;
    });

    form.querySelectorAll('[data-kk-native-range], [data-kk-price-range]').forEach(function (root) {
      var key = getRangeKey(root);

      if (key && rangesByKey[key]) {
        applyRangeState(root, rangesByKey[key]);
      }
    });

    return true;
  }

  function findSyntheticChangeTarget(form) {
    return form.querySelector('[data-filter-checkbox]') ||
      form.querySelector('[data-filter-range]') ||
      form.querySelector('[name]');
  }

  function dispatchCombinedFilterChange(snapshot) {
    var form = getFilterForm();
    var target;

    if (!form || !snapshot) {
      setFilterProcessing(false);
      return;
    }

    if (!applySnapshot(snapshot)) {
      setFilterProcessing(false);
      return;
    }

    if (getFormQuery(form) === snapshot.query && window.location.search.indexOf(snapshot.query) !== -1) {
      setFilterProcessing(false);
      return;
    }

    target = findSyntheticChangeTarget(form);

    if (!target) {
      setFilterProcessing(false);
      return;
    }

    replayingPendingSnapshot = true;
    setFilterProcessing(true);
    target.dispatchEvent(new Event('change', { bubbles: true }));

    window.setTimeout(function () {
      replayingPendingSnapshot = false;
    }, 0);
  }

  function flushPendingSnapshot() {
    var snapshot;

    window.clearTimeout(pendingFlushTimer);

    if (!pendingSnapshot || isFilterProcessing()) {
      return;
    }

    snapshot = pendingSnapshot;
    pendingSnapshot = null;
    dispatchCombinedFilterChange(snapshot);
  }

  function queuePendingSnapshot() {
    if (replayingPendingSnapshot) {
      return;
    }

    window.setTimeout(function () {
      if (!isFilterProcessing()) {
        return;
      }

      pendingSnapshot = snapshotFilterState() || pendingSnapshot;
      setFilterProcessing(true);
    }, 0);
  }

  function isNativeFilterTarget(target) {
    return Boolean(target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    ));
  }

  document.addEventListener('change', function (event) {
    if (isNativeFilterTarget(event.target)) {
      queuePendingSnapshot();
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab' && isNativeFilterTarget(event.target)) {
      queuePendingSnapshot();
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      syncFilterLoadingIcons();

      if (!pendingSnapshot) {
        return;
      }

      window.clearTimeout(pendingFlushTimer);
      pendingFlushTimer = window.setTimeout(flushPendingSnapshot, 30);
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncFilterLoadingIcons);
    window.visualViewport.addEventListener('scroll', syncFilterLoadingIcons);
  }

  window.addEventListener('resize', syncFilterLoadingIcons);
  syncFilterLoadingIcons();
}());

(function () {
  var activeDeferredInstance = null;
  var pendingDeferredApplyInstance = null;

  function isMobile() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function isMobileFilterModalOpen() {
    var modal = document.querySelector('[data-modal-container]');

    return Boolean(
      modal &&
      modal.classList.contains('modal--productgrid-filters') &&
      document.body.classList.contains('modal-visible') &&
      isMobile()
    );
  }

  function getDeferredInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (
      activeDeferredInstance &&
      activeDeferredInstance.el &&
      document.body.contains(activeDeferredInstance.el)
    ) {
      return activeDeferredInstance;
    }

    if (!instances) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (window.bcStaticSearch && instance instanceof window.bcStaticSearch) {
        found = instance;
        return true;
      }

      if (window.bcStaticCollection && instance instanceof window.bcStaticCollection) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function setFieldValue(input, value) {
    if (!input) return;
    input.value = Number.isInteger(value) ? String(value) : String(value).replace(/\.0$/, '');
  }

  function syncPriceRangeUi(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');
    var lowerValue = clamp(toNumber(minInput && minInput.value, min), min, max);
    var upperValue = clamp(toNumber(maxInput && maxInput.value, max), min, max);

    if (lowerValue > upperValue) {
      upperValue = lowerValue;
    }

    if (lower) lower.value = lowerValue;
    if (upper) upper.value = upperValue;
    setFieldValue(minInput, lowerValue);
    setFieldValue(maxInput, upperValue);
  }

  function syncNativeRangeUi(root) {
    var min = toNumber(root.dataset.kkRangeMin, 0);
    var max = toNumber(root.dataset.kkRangeMax, min);
    var values = [];
    var lower = root.querySelector('[data-kk-range-lower]');
    var upper = root.querySelector('[data-kk-range-upper]');
    var minInput = root.querySelector('[data-kk-range-min-input]');
    var maxInput = root.querySelector('[data-kk-range-max-input]');

    root.querySelectorAll('[data-kk-native-range-option]').forEach(function (option) {
      if (option.checked) {
        values.push(toNumber(option.dataset.kkRangeValue, min));
      }
    });

    if (!values.length) {
      values = [min, max];
    }

    values.sort(function (a, b) {
      return a - b;
    });

    if (lower) lower.value = values[0];
    if (upper) upper.value = values[values.length - 1];
    setFieldValue(minInput, values[0]);
    setFieldValue(maxInput, values[values.length - 1]);
  }

  function syncDeferredRangeUi(form) {
    form.querySelectorAll('[data-kk-price-range]').forEach(syncPriceRangeUi);
    form.querySelectorAll('[data-kk-native-range]').forEach(syncNativeRangeUi);
  }

  function getQueryStringFromHref(href) {
    try {
      return new URL(href || '', window.location.origin).search.replace(/^\?/, '');
    } catch (error) {
      return '';
    }
  }

  function applyQueryToFilterForm(queryString) {
    var form = document.querySelector('[data-filter-form]');
    var params = new URLSearchParams(queryString || '');
    var appliedTextFields = {};

    if (!form) {
      return false;
    }

    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name) {
        return;
      }

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = false;
      } else {
        field.value = '';
      }
    });

    params.forEach(function (value, name) {
      Array.prototype.forEach.call(form.elements, function (field) {
        if (field.name !== name) {
          return;
        }

        if (field.type === 'checkbox' || field.type === 'radio') {
          if (field.value === value) {
            field.checked = true;
          }
        } else if (!appliedTextFields[name]) {
          field.value = value;
          appliedTextFields[name] = true;
        }
      });
    });

    syncDeferredRangeUi(form);

    return true;
  }

  function updateDeferredRemoveUi(link) {
    var currentFilters = link.closest('.productgrid--sidebar-filters--current');
    var listItem = link.closest('li');

    if (!currentFilters) {
      return;
    }

    if (link.closest('.filter-item--grid-simple')) {
      currentFilters.remove();
      return;
    }

    if (listItem) {
      listItem.remove();
    }

    if (!currentFilters.querySelector('li')) {
      currentFilters.remove();
    }
  }

  function markDeferredDirty(instance) {
    if (!instance) {
      return;
    }

    if (instance.timeout !== null) {
      clearTimeout(instance.timeout);
      instance.timeout = null;
    }

    instance.kkMobileDeferredDirty = true;
    activeDeferredInstance = instance;
  }

  function queueDeferredApply(instance) {
    if (!instance || !instance.kkMobileDeferredDirty) {
      return;
    }

    pendingDeferredApplyInstance = instance;
  }

  function flushDeferredApply() {
    var instance = pendingDeferredApplyInstance;

    if (!instance || document.body.classList.contains('modal-visible')) {
      return;
    }

    pendingDeferredApplyInstance = null;

    if (!instance.kkMobileDeferredDirty) {
      return;
    }

    instance.kkMobileDeferredDirty = false;

    if (typeof instance._fetchResults === 'function') {
      instance.kkUseModalFilterFormForNextFetch = true;

      try {
        instance._fetchResults();
      } finally {
        instance.kkUseModalFilterFormForNextFetch = false;
      }
    }
  }

  function refreshOpenFilterModal(instance) {
    var modalWrapper = instance && instance.modal;
    var vanillaModal = modalWrapper && modalWrapper.modal;
    var modalContent = document.querySelector('[data-modal-container] [data-modal-content]');
    var freshSource = instance && instance.el ? instance.el.querySelector(instance.filterContentSelector) : null;

    if (!modalWrapper || !vanillaModal || !modalContent || !freshSource) {
      if (modalWrapper && modalWrapper.isOpen && modalWrapper.isOpen()) {
        modalWrapper.close();
      }

      return;
    }

    while (modalContent.firstChild) {
      modalContent.removeChild(modalContent.firstChild);
    }

    while (freshSource.firstChild) {
      modalContent.appendChild(freshSource.firstChild);
    }

    vanillaModal.current = freshSource;
    modalWrapper.position();
  }

  function patchStaticCollectionFaceted() {
    var proto = window.bcStaticCollection && window.bcStaticCollection.prototype;
    var originalHandleFilterClick;
    var originalHandleFilterRange;

    if (!proto || proto.kkNativeFilterFetchPatched) {
      return;
    }

    originalHandleFilterClick = proto._handleFilterClick;
    originalHandleFilterRange = proto._handleFilterRange;

    proto._getFilterParams = function () {
      var modalForm = this.kkUseModalFilterFormForNextFetch || isMobileFilterModalOpen() ?
        document.querySelector('[data-modal-container] ' + this.filterFormSelector) :
        null;
      var form = modalForm || (this.el && this.el.querySelector(this.filterFormSelector)) || document.querySelector(this.filterFormSelector);

      if (this.kkUsePendingFilterQueryForHistory && typeof this.kkPendingFilterQueryForHistory === 'string') {
        return this.kkPendingFilterQueryForHistory;
      }

      if (!form) {
        return '';
      }

      return new URLSearchParams(new FormData(form)).toString();
    };

    proto._handleFilterClick = function (targetEl) {
      var filterItem;

      if (isMobileFilterModalOpen()) {
        filterItem = targetEl && targetEl.closest('[data-filter-item]');

        if (filterItem) {
          filterItem.classList.toggle('filter-item--active');
          filterItem.classList.toggle('filter-item--inactive');
        }

        markDeferredDirty(this);
        return;
      }

      return originalHandleFilterClick.call(this, targetEl);
    };

    proto._handleFilterRange = function () {
      if (isMobileFilterModalOpen()) {
        markDeferredDirty(this);
        return;
      }

      return originalHandleFilterRange.apply(this, arguments);
    };

    proto._fetchResults = function (append, filterParams) {
      var processingType;
      var urlPath;
      var filterQuery;
      var queryString;
      var url;
      var priceMaxPromise;

      append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      filterParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      processingType = append ? 'pagination' : 'filter';
      urlPath = window.location.pathname;
      filterQuery = filterParams === null ? this._getFilterParams() : filterParams;

      if (!append) {
        this.queryParams.page = 1;
      }

      this.kkMobileDeferredDirty = false;
      queryString = this._stringifyQueryParams(this.queryParams);
      url = ''.concat(urlPath, '?').concat(queryString, '&').concat(filterQuery);
      priceMaxPromise = !append && window.kkContextualPriceMax ?
        window.kkContextualPriceMax.primeForUrl(url) :
        Promise.resolve(0);

      this._setProcessing(true, processingType);
      this._unbindEvents();

      Promise.all([
        fetch(url).then(function (response) {
          return response.text();
        }),
        priceMaxPromise
      ]).then(function (responses) {
        var html = responses[0];
        var maxPriceCents = responses[1];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        if (!append && window.kkContextualPriceMax && maxPriceCents > 0) {
          window.kkContextualPriceMax.applyToScope(doc.body, maxPriceCents, url);
        }

        if (append) {
          this._appendResults(doc.body);
        } else {
          this._replaceResults(doc.body);
        }

        this.kkPendingFilterQueryForHistory = filterQuery;
        this.kkUsePendingFilterQueryForHistory = true;
        this._updateHistory();
        this.kkUsePendingFilterQueryForHistory = false;
        this._bindEvents();
        this._handleViewToggle(null);
        this._setProcessing(false, processingType);

        if (this.modal.isOpen()) {
          if (!append && isMobileFilterModalOpen()) {
            refreshOpenFilterModal(this);
          } else {
            this.modal.close();
          }
        }
      }.bind(this));
    };

    proto.kkNativeFilterFetchPatched = true;
  }

  function getSearchFilterBaseUrl(instance) {
    var scopedField = instance && instance.el && instance.el.querySelector('[data-search-filter-form] [data-href]');
    var modalScopedField = document.querySelector('[data-modal-container] [data-search-filter-form] [data-href]');
    var fallbackField = instance && instance.el && instance.el.querySelector('[data-productgrid-filters-content] [data-href]');
    var modalFallbackField = document.querySelector('[data-modal-container] [data-productgrid-filters-content] [data-href]');
    var href = scopedField ? scopedField.getAttribute('data-href') : '';

    if (!href && modalScopedField) {
      href = modalScopedField.getAttribute('data-href');
    }

    if (!href && fallbackField) {
      href = fallbackField.getAttribute('data-href');
    }

    if (!href && modalFallbackField) {
      href = modalFallbackField.getAttribute('data-href');
    }

    return href || window.location.pathname + window.location.search;
  }

  function getSearchFilterForm(instance) {
    var modalForm = instance && (instance.kkUseModalFilterFormForNextFetch || isMobileFilterModalOpen()) ?
      document.querySelector('[data-modal-container] ' + instance.filterFormSelector) :
      null;

    return modalForm || (
      instance && instance.el && instance.el.querySelector(instance.filterFormSelector)
    ) || document.querySelector(instance.filterFormSelector);
  }

  function buildDeferredSearchFetchUrl(instance) {
    var form = getSearchFilterForm(instance);
    var baseUrl;
    var url;
    var formData;
    var fieldNames = {};

    if (!form) {
      return '';
    }

    baseUrl = getSearchFilterBaseUrl(instance);

    try {
      url = new URL(baseUrl, window.location.origin);
    } catch (error) {
      return baseUrl;
    }

    url.searchParams.delete('page');
    formData = new FormData(form);

    Array.prototype.forEach.call(form.elements, function (field) {
      if (field && field.name) {
        fieldNames[field.name] = true;
      }
    });

    Object.keys(fieldNames).forEach(function (name) {
      url.searchParams.delete(name);
    });

    new URLSearchParams(formData).forEach(function (value, name) {
      url.searchParams.append(name, value);
    });

    return url.pathname + url.search;
  }

  function patchStaticSearchInstance(instance) {
    var searchInstance = instance;
    var originalHandleFilterClick;
    var originalHandleRangeInput;
    var originalAjaxFetch;
    var originalGetFilterQuery;

    if (!instance || instance.kkMobileDeferredPatched) {
      return;
    }

    originalHandleFilterClick = instance._handleFilterClick;
    originalHandleRangeInput = instance._handleRangeInput;
    originalAjaxFetch = instance._ajaxFetch;
    originalGetFilterQuery = instance._getFilterQuery;

    instance._getFilterQuery = function (targetEl) {
      if (targetEl && targetEl.hasAttribute && targetEl.hasAttribute('data-filter-remove')) {
        return originalGetFilterQuery.call(searchInstance, targetEl);
      }

      var modalContainer = document.querySelector('[data-modal-container]');
      var modalForm = modalContainer && modalContainer.classList.contains('modal--productgrid-filters') ?
        modalContainer.querySelector(searchInstance.filterFormSelector) :
        null;
      var instanceForm = searchInstance.el && searchInstance.el.querySelector(searchInstance.filterFormSelector);
      var form = modalForm || instanceForm;

      if (!form) {
        return '';
      }

      return new URLSearchParams(new FormData(form)).toString();
    };

    instance._fetchResults = function () {
      var fetchUrl;

      if (searchInstance.processing) {
        return;
      }

      fetchUrl = buildDeferredSearchFetchUrl(searchInstance);

      if (!fetchUrl) {
        return;
      }

      searchInstance._ajaxFetch(fetchUrl, 1, 'change');
    };

    instance._ajaxFetch = function () {
      searchInstance.kkMobileDeferredDirty = false;
      return originalAjaxFetch.apply(searchInstance, arguments);
    };

    instance._handleFilterClick = function (event) {
      return originalHandleFilterClick(event);
    };

    instance._handleRangeInput = function (event) {
      return originalHandleRangeInput(event);
    };

    instance.kkMobileDeferredPatched = true;

    if (instance.ajaxEvents && typeof instance.ajaxEvents.unregisterAll === 'function') {
      instance.ajaxEvents.unregisterAll();
    }

    if (typeof instance._bindEvents === 'function') {
      instance._bindEvents();
    }
  }

  function patchStaticSearchFaceted() {
    var instances = window.bcSections && window.bcSections.instances;

    if (!instances || !window.bcStaticSearch) {
      return;
    }

    Object.keys(instances).forEach(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticSearch) {
        patchStaticSearchInstance(instance);
      }
    });
  }

  function handleDeferredNativeChange(event) {
    var instance;

    if (!isMobileFilterModalOpen()) {
      return;
    }

    if (event.type === 'keyup' && event.key === 'Tab') {
      return;
    }

    if (!event.target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    )) {
      return;
    }

    instance = getDeferredInstance();

    if (instance) {
      markDeferredDirty(instance);
    }
  }

  document.addEventListener('change', handleDeferredNativeChange, true);
  document.addEventListener('keyup', handleDeferredNativeChange, true);

  document.addEventListener('click', function (event) {
    var instance;
    var removeLink;
    var insideModal = event.target.closest('[data-modal-inner]');

    if (!isMobileFilterModalOpen()) {
      return;
    }

    removeLink = event.target.closest('[data-filter-remove]');

    if (removeLink) {
      instance = getDeferredInstance();

      if (!instance) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();

      applyQueryToFilterForm(getQueryStringFromHref(removeLink.getAttribute('href')));
      updateDeferredRemoveUi(removeLink);
      markDeferredDirty(instance);
      return;
    }

    if (event.target.closest('[data-modal-close]') || !insideModal) {
      queueDeferredApply(getDeferredInstance());
      window.setTimeout(flushDeferredApply, 0);
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isMobileFilterModalOpen()) {
      queueDeferredApply(getDeferredInstance());
      window.setTimeout(flushDeferredApply, 0);
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(flushDeferredApply).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchStaticCollectionFaceted();
      patchStaticSearchFaceted();
    });
  } else {
    patchStaticCollectionFaceted();
    patchStaticSearchFaceted();
  }
}());

(function () {
  var keepFilterModalOpen = false;
  var manualCloseUntil = 0;
  var reopenTimer = null;
  var filterModalScrollTop = 0;

  function isMobile() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function getModalContainer() {
    return document.querySelector('[data-modal-container]');
  }

  function isFilterModalOpen() {
    var modal = getModalContainer();

    return Boolean(
      modal &&
      modal.classList.contains('modal--productgrid-filters') &&
      document.body.classList.contains('modal-visible')
    );
  }

  function getFloatingWidgetElements() {
    var selectors = [
      '.chat-app',
      '.chat-toggle',
      '[class*="chat-app"]',
      '[class*="chat-toggle"]',
      '[class*="chat"]',
      '[id*="chat"]',
      '[aria-label*="chat" i]',
      '[title*="chat" i]',
      '[id*="gorgias" i]',
      '[class*="gorgias" i]',
      '[id*="intercom" i]',
      '[class*="intercom" i]',
      '[id*="crisp" i]',
      '[class*="crisp" i]',
      '[data-spec="toggle-button"]',
      'iframe[src*="chat" i]',
      'iframe[src*="gorgias" i]',
      'iframe[src*="intercom" i]',
      'iframe[src*="crisp" i]',
      '#smile-ui-lite-launcher-frame-container',
      '[data-kk-filter-widget-hidden]'
    ];
    var elements = [];
    var modal = getModalContainer();

    function addElement(element) {
      if (
        !element ||
        element === document.documentElement ||
        element === document.body ||
        (modal && (element === modal || modal.contains(element))) ||
        elements.indexOf(element) !== -1
      ) {
        return;
      }

      elements.push(element);
    }

    function getElementText(element) {
      return [
        element.id,
        element.className,
        element.getAttribute && element.getAttribute('aria-label'),
        element.getAttribute && element.getAttribute('title'),
        element.getAttribute && element.getAttribute('data-spec'),
        element.getAttribute && element.getAttribute('src')
      ].join(' ').toLowerCase();
    }

    function isNamedFloatingWidget(element) {
      var text = getElementText(element);

      return (
        text.indexOf('chat') !== -1 ||
        text.indexOf('gorgias') !== -1 ||
        text.indexOf('intercom') !== -1 ||
        text.indexOf('crisp') !== -1 ||
        text.indexOf('toggle-button') !== -1 ||
        text.indexOf('smile') !== -1
      );
    }

    function isBottomFloatingElement(element) {
      var rect;
      var style;
      var zIndex;

      if (!element.getBoundingClientRect) {
        return false;
      }

      style = window.getComputedStyle ? window.getComputedStyle(element) : null;

      if (!style || (style.position !== 'fixed' && style.position !== 'sticky')) {
        return false;
      }

      if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
      }

      rect = element.getBoundingClientRect();

      if (!rect.width || !rect.height) {
        return false;
      }

      zIndex = parseInt(style.zIndex, 10);

      return (
        rect.bottom > window.innerHeight - 180 &&
        rect.top < window.innerHeight &&
        rect.right > 0 &&
        rect.left < window.innerWidth &&
        (
          isNamedFloatingWidget(element) ||
          (!isNaN(zIndex) && zIndex >= 100) ||
          (rect.width <= 260 && rect.height <= 180)
        )
      );
    }

    function collectFromRoot(root) {
      if (!root || !root.querySelectorAll) {
        return;
      }

      selectors.forEach(function (selector) {
        try {
          root.querySelectorAll(selector).forEach(addElement);
        } catch (error) {
          // Ignore unsupported third-party selector shapes in older browsers.
        }
      });

      root.querySelectorAll('*').forEach(function (element) {
        if (isBottomFloatingElement(element)) {
          addElement(element);
        }

        if (element.shadowRoot) {
          collectFromRoot(element.shadowRoot);
        }
      });
    }

    collectFromRoot(document);

    return elements;
  }

  function setFloatingWidgetsHidden(hidden) {
    getFloatingWidgetElements().forEach(function (element) {
      if (hidden) {
        if (!element.hasAttribute('data-kk-filter-widget-hidden')) {
          element.setAttribute('data-kk-filter-widget-display', element.style.getPropertyValue('display'));
          element.setAttribute('data-kk-filter-widget-display-priority', element.style.getPropertyPriority('display'));
          element.setAttribute('data-kk-filter-widget-visibility', element.style.getPropertyValue('visibility'));
          element.setAttribute('data-kk-filter-widget-visibility-priority', element.style.getPropertyPriority('visibility'));
          element.setAttribute('data-kk-filter-widget-pointer-events', element.style.getPropertyValue('pointer-events'));
          element.setAttribute('data-kk-filter-widget-pointer-events-priority', element.style.getPropertyPriority('pointer-events'));
          element.setAttribute('data-kk-filter-widget-hidden', 'true');
        }

        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
        return;
      }

      if (!element.hasAttribute('data-kk-filter-widget-hidden')) {
        return;
      }

      element.style.setProperty(
        'display',
        element.getAttribute('data-kk-filter-widget-display') || '',
        element.getAttribute('data-kk-filter-widget-display-priority') || ''
      );
      element.style.setProperty(
        'visibility',
        element.getAttribute('data-kk-filter-widget-visibility') || '',
        element.getAttribute('data-kk-filter-widget-visibility-priority') || ''
      );
      element.style.setProperty(
        'pointer-events',
        element.getAttribute('data-kk-filter-widget-pointer-events') || '',
        element.getAttribute('data-kk-filter-widget-pointer-events-priority') || ''
      );

      [
        'data-kk-filter-widget-display',
        'data-kk-filter-widget-display-priority',
        'data-kk-filter-widget-visibility',
        'data-kk-filter-widget-visibility-priority',
        'data-kk-filter-widget-pointer-events',
        'data-kk-filter-widget-pointer-events-priority',
        'data-kk-filter-widget-hidden'
      ].forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  }

  function syncFilterModalWidgetVisibility() {
    var hidden = isMobile() && isFilterModalOpen();

    if (!document.body) {
      return;
    }

    document.body.classList.toggle(
      'kk-filter-modal-visible',
      hidden
    );
    setFloatingWidgetsHidden(hidden);
  }

  function isNativeFilterTarget(target) {
    return Boolean(target && target.closest(
      '[data-filter-checkbox], [data-filter-range], [data-filter-remove], [data-kk-range-lower], [data-kk-range-upper], [data-kk-range-min-input], [data-kk-range-max-input]'
    ));
  }

  function rememberFilterModalScroll() {
    var modal = getModalContainer();

    if (modal) {
      filterModalScrollTop = modal.scrollTop;
    }
  }

  function restoreFilterModalScroll() {
    var modal = getModalContainer();

    if (modal && document.body.classList.contains('modal-visible')) {
      modal.scrollTop = filterModalScrollTop;
    }
  }

  function markFilterModalDirty(target) {
    if (isMobile() && isFilterModalOpen() && isNativeFilterTarget(target)) {
      rememberFilterModalScroll();
      keepFilterModalOpen = true;
      manualCloseUntil = 0;
    }
  }

  function markManualClose() {
    keepFilterModalOpen = false;
    manualCloseUntil = Date.now() + 10000;
    syncFilterModalWidgetVisibility();
  }

  function shouldReopenFilterModal() {
    return Boolean(
      keepFilterModalOpen &&
      isMobile() &&
      Date.now() > manualCloseUntil &&
      !document.body.classList.contains('modal-visible') &&
      document.querySelector('[data-productgrid-trigger-filters]')
    );
  }

  function reopenFilterModal() {
    var trigger;

    window.clearTimeout(reopenTimer);

    if (!shouldReopenFilterModal()) {
      return;
    }

    trigger = document.querySelector('[data-productgrid-trigger-filters]');

    if (trigger) {
      trigger.dispatchEvent(new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      }));

      window.setTimeout(restoreFilterModalScroll, 120);
      window.setTimeout(syncFilterModalWidgetVisibility, 130);
    }
  }

  function queueReopenFilterModal() {
    syncFilterModalWidgetVisibility();
    window.clearTimeout(reopenTimer);

    if (!shouldReopenFilterModal()) {
      return;
    }

    reopenTimer = window.setTimeout(reopenFilterModal, 80);
  }

  document.addEventListener('change', function (event) {
    markFilterModalDirty(event.target);
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Tab') {
      markFilterModalDirty(event.target);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var modalInner = event.target.closest('[data-modal-inner]');

    if (!isMobile() || !isFilterModalOpen()) {
      return;
    }

    if (
      event.target.closest('[data-kk-filter-results-button]') ||
      event.target.closest('.modal--productgrid-filters [data-modal-close]') ||
      !modalInner
    ) {
      markManualClose();
      return;
    }

    markFilterModalDirty(event.target);
    syncFilterModalWidgetVisibility();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isFilterModalOpen()) {
      markManualClose();
    }
  }, true);

  window.addEventListener('resize', syncFilterModalWidgetVisibility);

  if (window.MutationObserver) {
    new MutationObserver(queueReopenFilterModal).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    new MutationObserver(queueReopenFilterModal).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  syncFilterModalWidgetVisibility();
}());

(function () {
  function decodeScopedSearchValue(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
    } catch (error) {
      return String(value || '').replace(/\+/g, ' ');
    }
  }

  function trimScopedSearchValue(value) {
    return decodeScopedSearchValue(value).trim();
  }

  function escapeScopedSearchValue(value) {
    return trimScopedSearchValue(value)
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"')
      .replace(/([:()])/g, '\\$1');
  }

  function unescapeScopedSearchValue(value) {
    return String(value || '')
      .replace(/&amp;quot;/g, '"')
      .replace(/&quot;/g, '"')
      .replace(/&#34;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&')
      .replace(/\\(.)/g, '$1');
  }

  function buildScopedSearchQuery(value) {
    return trimScopedSearchValue(value);
  }

  function extractScopedSearchTerm(value) {
    var query = unescapeScopedSearchValue(trimScopedSearchValue(value));
    var matches = query.match(/^title:"((?:\\.|[^"])*)" OR vendor:"((?:\\.|[^"])*)"$/);

    if (matches && matches[1] === matches[2]) {
      return unescapeScopedSearchValue(matches[1]);
    }

    if (query.indexOf('title:') === 0 && query.indexOf(' OR vendor:') !== -1) {
      return query
        .split('title:').pop()
        .split(' OR vendor:')[0]
        .replace(/^"+|"+$/g, '');
    }

    return query;
  }

  window.kkScopedSearch = {
    buildQuery: buildScopedSearchQuery,
    decodeValue: decodeScopedSearchValue,
    extractTerm: extractScopedSearchTerm,
    trimValue: trimScopedSearchValue
  };
}());

(function () {
  function getScopedSearchHelpers() {
    return window.kkScopedSearch || null;
  }

  function syncScopedSearchForm(form) {
    var helpers = getScopedSearchHelpers();
    var visibleInput = form && form.querySelector('[data-kk-search-visible-input]');
    var queryInput = form && form.querySelector('[data-kk-search-query-input]');

    if (!helpers || !visibleInput || !queryInput) {
      return;
    }

    queryInput.value = helpers.buildQuery(visibleInput.value);
  }

  document.addEventListener('input', function (event) {
    var visibleInput = event.target.closest('[data-kk-search-visible-input]');

    if (!visibleInput) {
      return;
    }

    syncScopedSearchForm(visibleInput.closest('[data-live-search-form]'));
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-live-search-form]');

    if (!form) {
      return;
    }

    syncScopedSearchForm(form);
  }, true);

  function initScopedSearchForms() {
    document.querySelectorAll('[data-live-search-form]').forEach(syncScopedSearchForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScopedSearchForms);
  } else {
    initScopedSearchForms();
  }
}());

(function () {
  var NAVIGATING_ATTR = 'data-kk-live-search-navigating';
  var SUBMITTING_ATTR = 'data-kk-live-search-submitting';
  var TOUCH_MOVE_TOLERANCE = 12;
  var touchCandidate = null;

  function isMobileViewport() {
    if (window.matchMedia) {
      return window.matchMedia('(max-width: 859px)').matches;
    }

    return window.innerWidth <= 859;
  }

  function findLiveSearchResultLink(target) {
    var link = target && target.closest ? target.closest('a[href]') : null;

    if (!link || !link.closest('[data-live-search]')) {
      return null;
    }

    if (!link.closest('[data-live-search-results], [data-live-search-flydown]')) {
      return null;
    }

    if (!link.closest('.kk-predictive-search')) {
      return null;
    }

    return link;
  }

  function findLiveSearchContinueButton(target) {
    var button = target && target.closest ? target.closest('button.kk-predictive-search__continue') : null;

    if (!button || !button.closest('[data-live-search]')) {
      return null;
    }

    if (!button.closest('[data-live-search-results], [data-live-search-flydown]')) {
      return null;
    }

    if (!button.closest('.kk-predictive-search')) {
      return null;
    }

    return button;
  }

  function canNavigateLiveSearchLink(link, event) {
    var href;

    if (!link || !isMobileViewport()) {
      return false;
    }

    href = link.getAttribute('href');

    if (!href || href === '#' || link.hasAttribute('download')) {
      return false;
    }

    if (link.target && link.target !== '_self') {
      return false;
    }

    if (event && event.type === 'click') {
      if (event.button && event.button !== 0) {
        return false;
      }

      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return false;
      }
    }

    return true;
  }

  function canSubmitLiveSearchContinue(button) {
    if (!button || !isMobileViewport()) {
      return false;
    }

    if (button.disabled || button.classList.contains('kk-predictive-search__continue--pending')) {
      return false;
    }

    return true;
  }

  function getLiveSearchResultsUrl(form) {
    var action = form && form.getAttribute('action') ? form.getAttribute('action') : '/search';
    var url = new URL(action, window.location.origin);
    var params = new URLSearchParams(form ? new FormData(form) : undefined);
    var visibleInput = form && form.querySelector('[data-kk-search-visible-input]');
    var queryInput = form && form.querySelector('[data-kk-search-query-input]');
    var rawQuery = visibleInput ? visibleInput.value : params.get('q');
    var query = window.kkScopedSearch && typeof window.kkScopedSearch.buildQuery === 'function' ?
      window.kkScopedSearch.buildQuery(rawQuery || '') :
      (rawQuery || '');

    if (queryInput) {
      queryInput.value = query;
    }

    params.set('q', query);

    if (!params.get('type')) {
      params.set('type', 'product');
    }

    url.search = params.toString();

    return url.toString();
  }

  function openLiveSearchLink(link, event) {
    if (!canNavigateLiveSearchLink(link, event)) {
      return;
    }

    if (link.getAttribute(NAVIGATING_ATTR) === 'true') {
      return;
    }

    link.setAttribute(NAVIGATING_ATTR, 'true');

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    window.location.assign(link.href);
  }

  function openLiveSearchResults(button, event) {
    var form;

    if (!canSubmitLiveSearchContinue(button)) {
      return;
    }

    form = button.form || button.closest('[data-live-search-form]');

    if (!form || button.getAttribute(SUBMITTING_ATTR) === 'true') {
      return;
    }

    button.setAttribute(SUBMITTING_ATTR, 'true');

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    window.location.assign(getLiveSearchResultsUrl(form));
  }

  document.addEventListener('touchstart', function (event) {
    var link = findLiveSearchResultLink(event.target);
    var continueButton = findLiveSearchContinueButton(event.target);
    var touch = event.touches && event.touches[0];

    if (!touch) {
      touchCandidate = null;
      return;
    }

    if (!canNavigateLiveSearchLink(link, event) && !canSubmitLiveSearchContinue(continueButton)) {
      touchCandidate = null;
      return;
    }

    touchCandidate = {
      action: link ? 'link' : 'continue',
      target: link || continueButton,
      x: touch.clientX,
      y: touch.clientY
    };
  }, true);

  document.addEventListener('touchend', function (event) {
    var target;
    var touch;
    var moved;

    if (!touchCandidate) {
      return;
    }

    target = touchCandidate.action === 'link' ?
      findLiveSearchResultLink(event.target) :
      findLiveSearchContinueButton(event.target);
    touch = event.changedTouches && event.changedTouches[0];

    moved = touch ? (
      Math.abs(touch.clientX - touchCandidate.x) > TOUCH_MOVE_TOLERANCE ||
      Math.abs(touch.clientY - touchCandidate.y) > TOUCH_MOVE_TOLERANCE
    ) : false;

    if (target && target === touchCandidate.target && !moved) {
      if (touchCandidate.action === 'link') {
        openLiveSearchLink(target, event);
      } else {
        openLiveSearchResults(target, event);
      }
    }

    touchCandidate = null;
  }, true);

  document.addEventListener('touchcancel', function () {
    touchCandidate = null;
  }, true);

  document.addEventListener('click', function (event) {
    openLiveSearchResults(findLiveSearchContinueButton(event.target), event);
    openLiveSearchLink(findLiveSearchResultLink(event.target), event);
  }, true);
}());

(function () {
  var SEARCH_SECTION_ID = 'kk-collection-search';
  var SEARCH_PAGINATION = 'click_to_load';

  function decodeQueryValue(value) {
    try {
      return decodeURIComponent(String(value || '').replace(/\+/g, '%20'));
    } catch (error) {
      return String(value || '').replace(/\+/g, ' ');
    }
  }

  function trimSearchTerm(value) {
    return decodeQueryValue(value).trim();
  }

  function encodeQueryValue(value) {
    var params = new URLSearchParams();

    params.set('q', value);

    return params.toString().replace(/^q=/, '');
  }

  function getSearchBaseUrl() {
    return window.Theme && window.Theme.routes && window.Theme.routes.search_url ?
      window.Theme.routes.search_url :
      '/search';
  }

  function isSearchMode(instance) {
    return Boolean(instance && instance.queryParams && trimSearchTerm(instance.queryParams.q));
  }

  function findCollectionInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (!instances || !window.bcStaticCollection) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticCollection) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function setSearchPagination(instance) {
    if (!instance) {
      return;
    }

    if (!instance.kkOriginalPagination) {
      instance.kkOriginalPagination = instance.pagination;
    }

    instance.pagination = SEARCH_PAGINATION;
  }

  function restorePagination(instance) {
    if (instance && instance.kkOriginalPagination) {
      instance.pagination = instance.kkOriginalPagination;
    }
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(String(value || '').replace(',', '.'));

    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function isDefaultPriceParam(instance, name, value) {
    var priceRange = instance && instance.el && instance.el.querySelector ?
      instance.el.querySelector('[data-kk-price-range]') :
      null;
    var min;
    var max;
    var numericValue;

    if (!priceRange || (name !== 'filter.v.price.gte' && name !== 'filter.v.price.lte')) {
      return false;
    }

    if (String(value || '') === '') {
      return true;
    }

    min = toNumber(priceRange.dataset.kkRangeMin, 0);
    max = toNumber(priceRange.dataset.kkRangeMax, null);
    numericValue = toNumber(value, null);

    if (numericValue === null || max === null) {
      return false;
    }

    if (name === 'filter.v.price.gte') {
      return numericValue <= min || Math.abs(numericValue - min) < 0.0001;
    }

    return numericValue >= max || Math.abs(numericValue - max) < 0.0001;
  }

  function sanitizeFilterQuery(instance, filterParams) {
    var params = new URLSearchParams(filterParams || '');
    var remaining = new URLSearchParams();

    params.forEach(function (value, name) {
      if (isDefaultPriceParam(instance, name, value)) {
        return;
      }

      if (name === 'q') {
        if (value) {
          instance.queryParams.q = encodeQueryValue(value);
        } else {
          delete instance.queryParams.q;
        }
        return;
      }

      if (name === 'sort_by') {
        if (value) {
          instance.queryParams.sort_by = value;
        } else {
          delete instance.queryParams.sort_by;
        }
        return;
      }

      if (name === 'page') {
        instance.queryParams.page = parseInt(value, 10) || 1;
        return;
      }

      if (name === 'grid_list') {
        if (value) {
          instance.queryParams.grid_list = value;
        }
        return;
      }

      if (name === 'type' || name === 'section_id' || name === 'sections') {
        return;
      }

      remaining.append(name, value);
    });

    return remaining.toString();
  }

  function buildSearchSectionUrl(instance, filterQuery) {
    var params = new URLSearchParams();

    params.set('section_id', SEARCH_SECTION_ID);
    params.set('type', 'product');
    params.set('q', trimSearchTerm(instance.queryParams.q));

    if (instance.queryParams.sort_by) {
      params.set('sort_by', instance.queryParams.sort_by);
    }

    if (instance.queryParams.page && instance.queryParams.page > 1) {
      params.set('page', instance.queryParams.page);
    }

    if (filterQuery) {
      new URLSearchParams(filterQuery).forEach(function (value, name) {
        params.append(name, value);
      });
    }

    return getSearchBaseUrl() + '?' + params.toString();
  }

  function replaceSidebarFilters(instance, html) {
    var sidebarContainer = instance.el.querySelector(instance.sidebarContainerSelector);
    var currentFilters = sidebarContainer && sidebarContainer.querySelector('[data-productgrid-filters-content]');
    var nextFilters = html.querySelector('[data-kk-search-sidebar-filters]');

    if (!sidebarContainer) {
      return;
    }

    if (nextFilters && currentFilters) {
      currentFilters.outerHTML = nextFilters.outerHTML;
      return;
    }

    if (nextFilters && !currentFilters) {
      sidebarContainer.insertAdjacentHTML('afterbegin', nextFilters.outerHTML);
      return;
    }

    if (!nextFilters && currentFilters) {
      currentFilters.remove();
    }
  }

  function replaceSortModal(instance, html) {
    var currentSortModal = document.querySelector(instance.sortContentSelector);
    var nextSortModal = html.querySelector(instance.sortContentSelector);

    if (currentSortModal && nextSortModal) {
      currentSortModal.outerHTML = nextSortModal.outerHTML;
    } else if (!currentSortModal && nextSortModal) {
      instance.el.insertAdjacentHTML('beforeend', nextSortModal.outerHTML);
    }
  }

  function patchStaticCollectionSearchMode() {
    var proto = window.bcStaticCollection && window.bcStaticCollection.prototype;
    var originalFetchResults;
    var originalReplaceResults;
    var originalAppendResults;
    var originalSetProcessing;
    var rimgWatchEvent;

    if (!proto || proto.kkEmbeddedSearchPatched) {
      return;
    }

    originalFetchResults = proto._fetchResults;
    originalReplaceResults = proto._replaceResults;
    originalAppendResults = proto._appendResults;
    originalSetProcessing = proto._setProcessing;
    rimgWatchEvent = typeof CustomEvent === 'function' ?
      function (target) {
        target.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
      } :
      function () {};

    function getResponseProductCount(container) {
      var responseContainer = container && container.querySelector('[data-results-container][data-product-count]');
      var count = responseContainer ? parseInt(responseContainer.getAttribute('data-product-count'), 10) : null;

      return isNaN(count) ? null : count;
    }

    proto._setProcessing = function () {
      var processing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'filter';
      var sidebarContainer;
      var responseContainer;

      if (!isSearchMode(this) || type !== 'filter') {
        return originalSetProcessing.apply(this, arguments);
      }

      this.processing = processing;
      sidebarContainer = this.el.querySelector(this.sidebarContainerSelector);
      responseContainer = this.el.querySelector(this.responseContainerSelector);

      if (sidebarContainer) {
        sidebarContainer.classList.toggle('processing--' + type, processing);
      }

      if (responseContainer) {
        responseContainer.classList.toggle('processing--' + type, processing);
      }
    };

    proto._replaceResults = function (html) {
      var responseContainer;
      var nextResponseContainer;

      if (!isSearchMode(this)) {
        restorePagination(this);
        return originalReplaceResults.call(this, html);
      }

      responseContainer = this.el.querySelector(this.responseContainerSelector);
      nextResponseContainer = html.querySelector(this.responseContainerSelector);

      if (!responseContainer || !nextResponseContainer) {
        return originalReplaceResults.call(this, html);
      }

      this.initializedProductCards.forEach(function (item) {
        item.unload();
      });
      this.initializedProductCards = [];
      this._unbindEvents();

      responseContainer.innerHTML = nextResponseContainer.innerHTML;
      if (nextResponseContainer.hasAttribute('data-product-count')) {
        responseContainer.setAttribute('data-product-count', nextResponseContainer.getAttribute('data-product-count'));
      } else {
        responseContainer.removeAttribute('data-product-count');
      }
      this._initProductCards(responseContainer.querySelectorAll(this.productItemSelector));
      rimgWatchEvent(responseContainer);

      replaceSidebarFilters(this, html);
      replaceSortModal(this, html);
    };

    proto._appendResults = function (html) {
      if (!isSearchMode(this)) {
        restorePagination(this);
        return originalAppendResults.call(this, html);
      }

      return originalAppendResults.call(this, html);
    };

    proto._fetchResults = function () {
      var append = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var filterParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var processingType = append ? 'pagination' : 'filter';
      var hasExplicitPage = filterParams !== null && /(^|&)page=/.test(filterParams);
      var filterQuery = sanitizeFilterQuery(this, filterParams === null ? this._getFilterParams() : filterParams);
      var url;
      var priceMaxPromise;

      if (!append && !hasExplicitPage) {
        this.queryParams.page = 1;
      }

      if (!isSearchMode(this)) {
        restorePagination(this);
        return originalFetchResults.call(this, append, filterQuery);
      }

      setSearchPagination(this);
      url = buildSearchSectionUrl(this, filterQuery);
      priceMaxPromise = !append && window.kkContextualPriceMax ?
        window.kkContextualPriceMax.primeForUrl(url) :
        Promise.resolve(0);

      this._setProcessing(true, processingType);
      this._unbindEvents();

      Promise.all([
        fetch(url).then(function (response) {
          if (!response.ok) {
            throw new Error('Embedded collection search failed with status ' + response.status);
          }

          return response.text();
        }),
        priceMaxPromise
      ]).then(function (responses) {
        var html = responses[0];
        var maxPriceCents = responses[1];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var resultCount = getResponseProductCount(doc.body);

        if (!append && window.kkContextualPriceMax && maxPriceCents > 0) {
          window.kkContextualPriceMax.applyToScope(doc.body, maxPriceCents, url);
        }

        if (append) {
          this._appendResults(doc.body);
        } else {
          this._replaceResults(doc.body);
        }

        this.kkPendingFilterQueryForHistory = filterQuery;
        this.kkUsePendingFilterQueryForHistory = true;
        this._updateHistory();
        this.kkUsePendingFilterQueryForHistory = false;
        this._bindEvents();
        this._handleViewToggle(null);
        this._setProcessing(false, processingType);
        document.dispatchEvent(new CustomEvent('kk:collection-search-complete', {
          detail: {
            resultCount: resultCount
          }
        }));

        if (this.modal.isOpen()) {
          this.modal.close();
        }
      }.bind(this)).catch(function (error) {
        console.error(error);
        this._setProcessing(false, processingType);
        restorePagination(this);
        document.dispatchEvent(new CustomEvent('kk:collection-search-error'));
      }.bind(this));
    };

    proto.kkEmbeddedSearchPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchStaticCollectionSearchMode);
  } else {
    patchStaticCollectionSearchMode();
  }
}());

(function () {
  var COLLECTION_AUTO_SEARCH_DELAY = 1000;

  function getScopedSearchHelpers() {
    return window.kkScopedSearch || null;
  }

  function isMobileSearchUi() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function encodeSearchTerm(term) {
    var helpers = getScopedSearchHelpers();
    var params = new URLSearchParams();
    var query = helpers ? helpers.buildQuery(term) : term;

    params.set('q', query);

    return params.toString().replace(/^q=/, '');
  }

  function decodeSearchTerm(term) {
    try {
      return decodeURIComponent(String(term || '').replace(/\+/g, '%20'));
    } catch (error) {
      return String(term || '').replace(/\+/g, ' ');
    }
  }

  function getSearchUrl(term) {
    var helpers = getScopedSearchHelpers();
    var url = new URL(window.Theme && window.Theme.routes && window.Theme.routes.search_url ?
      window.Theme.routes.search_url :
      '/search', window.location.origin);

    url.searchParams.set('type', 'product');
    url.searchParams.set('q', helpers ? helpers.buildQuery(term) : term);

    return url.pathname + (url.search ? url.search : '');
  }

  function getPredictiveState(root) {
    if (!root._kkCollectionPredictiveState) {
      root._kkCollectionPredictiveState = {
        requestId: 0,
        timer: null
      };
    }

    return root._kkCollectionPredictiveState;
  }

  function getPredictiveQuery(term) {
    var helpers = getScopedSearchHelpers();

    return helpers ? helpers.buildQuery(term) : term;
  }

  function getPredictiveFlydown(root) {
    var flydown = root.querySelector('[data-kk-collection-search-predictive]');

    if (!flydown) {
      flydown = document.createElement('div');
      flydown.className = 'kk-collection-search__predictive';
      flydown.setAttribute('data-kk-collection-search-predictive', '');
      flydown.setAttribute('role', 'region');
      flydown.hidden = true;
      root.appendChild(flydown);
    }

    return flydown;
  }

  function getPredictiveSearchUrl(searchQuery) {
    var url = new URL(window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url ?
      window.Theme.routes.predictive_search_url :
      '/search/suggest', window.location.origin);

    url.searchParams.set('q', searchQuery);
    url.searchParams.set('section_id', 'predictive-search');

    return url.toString();
  }

  function getStaticSearchUrl(searchQuery) {
    var url = new URL(window.Theme && window.Theme.routes && window.Theme.routes.search_url ?
      window.Theme.routes.search_url :
      '/search', window.location.origin);

    url.searchParams.set('section_id', 'static-search');
    url.searchParams.set('type', 'product');
    url.searchParams.set('q', searchQuery);

    return url.toString();
  }

  function showPredictivePending(root) {
    var flydown = getPredictiveFlydown(root);

    flydown.hidden = false;
    flydown.setAttribute('aria-busy', 'true');
    flydown.innerHTML = [
      '<div class="kk-predictive-search kk-predictive-search--pending visible" data-predictive-search>',
      '<div class="search-flydown__no-results kk-predictive-search__pending-body"></div>',
      '<div class="search-flydown__footer kk-predictive-search__footer kk-predictive-search__footer--pending">',
      '<span class="kk-predictive-search__continue kk-predictive-search__continue--pending" aria-hidden="true"></span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function hidePredictiveSearch(root) {
    var state = getPredictiveState(root);
    var flydown = root.querySelector('[data-kk-collection-search-predictive]');

    state.requestId += 1;
    window.clearTimeout(state.timer);
    state.timer = null;

    if (!flydown) {
      return;
    }

    flydown.hidden = true;
    flydown.removeAttribute('aria-busy');
    flydown.innerHTML = '';
  }

  function updatePredictiveCount(flydown, searchQuery, requestId, state) {
    var countLabel = flydown.querySelector('[data-kk-predictive-search-count-label]');

    if (!countLabel) {
      return;
    }

    function updateCountLabel(count) {
      var numericCount = parseInt(count, 10);
      var template;

      if (isNaN(numericCount)) {
        return;
      }

      template = numericCount === 1 ?
        countLabel.getAttribute('data-kk-predictive-search-count-template-one') :
        countLabel.getAttribute('data-kk-predictive-search-count-template-other');

      if (!template) {
        return;
      }

      countLabel.textContent = template.replace(/\[\[count\]\]/g, numericCount);
    }

    fetch(getStaticSearchUrl(searchQuery)).then(function (response) {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    }).then(function (html) {
      var parsed;
      var resultsContainer;
      var productCount;

      if (requestId !== state.requestId) {
        return;
      }

      parsed = new DOMParser().parseFromString(html, 'text/html');
      resultsContainer = parsed.querySelector('[data-results-container][data-product-count]');

      if (!resultsContainer) {
        return;
      }

      productCount = resultsContainer.getAttribute('data-product-count');

      if (productCount !== null) {
        updateCountLabel(productCount);
      }
    }).catch(function () {});
  }

  function fetchPredictiveSearch(root, term) {
    var state = getPredictiveState(root);
    var requestId = state.requestId + 1;
    var searchQuery = getPredictiveQuery(term);

    state.requestId = requestId;

    fetch(getPredictiveSearchUrl(searchQuery)).then(function (response) {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    }).then(function (html) {
      var flydown;

      if (requestId !== state.requestId) {
        return;
      }

      flydown = getPredictiveFlydown(root);
      flydown.innerHTML = html;
      flydown.hidden = false;
      flydown.setAttribute('aria-busy', 'false');
      updatePredictiveCount(flydown, searchQuery, requestId, state);
    }).catch(function () {
      if (requestId === state.requestId) {
        hidePredictiveSearch(root);
      }
    });
  }

  function queuePredictiveSearch(root) {
    var parts = getParts(root);
    var term = parts.input ? parts.input.value.trim() : '';
    var state = getPredictiveState(root);

    window.clearTimeout(state.timer);

    if (!term) {
      hidePredictiveSearch(root);
      return;
    }

    showPredictivePending(root);
    state.timer = window.setTimeout(function () {
      fetchPredictiveSearch(root, term);
    }, 220);
  }

  function getAutoSearchState(root) {
    if (!root._kkCollectionAutoSearchState) {
      root._kkCollectionAutoSearchState = {
        timer: null
      };
    }

    return root._kkCollectionAutoSearchState;
  }

  function clearQueuedAutoSearch(root) {
    var state = getAutoSearchState(root);

    window.clearTimeout(state.timer);
    state.timer = null;
  }

  function queueAutoSearch(root) {
    var state = getAutoSearchState(root);

    clearQueuedAutoSearch(root);

    state.timer = window.setTimeout(function () {
      var parts = getParts(root);
      var term = parts.input ? parts.input.value.trim() : '';

      if (term) {
        runEmbeddedSearch(root, { allowRedirect: true });
      } else {
        runEmbeddedSearch(root);
      }
    }, COLLECTION_AUTO_SEARCH_DELAY);
  }

  function getParts(root) {
    return {
      input: root.querySelector('[data-kk-collection-search-input]'),
      submit: root.querySelector('[data-kk-collection-search-submit]'),
      clear: root.querySelector('[data-kk-collection-search-clear]')
    };
  }

  function getStatus(root) {
    var status = root.querySelector('[data-kk-collection-search-status]');

    if (!status) {
      status = document.createElement('div');
      status.className = 'kk-collection-search__status';
      status.setAttribute('data-kk-collection-search-status', '');
      status.setAttribute('aria-live', 'polite');
      root.appendChild(status);
    }

    return status;
  }

  function updateStatus(root, message) {
    var status = getStatus(root);

    status.textContent = message || '';
    status.hidden = !message;
  }

  function getResultCount(root) {
    var instance = findCollectionInstance();
    var resultsContainer = null;
    var count = null;

    if (root && root.dataset && root.dataset.kkCollectionSearchCount) {
      count = parseInt(root.dataset.kkCollectionSearchCount, 10);
      return isNaN(count) ? null : count;
    }

    if (instance && instance.el && typeof instance.el.querySelector === 'function') {
      resultsContainer = instance.el.querySelector('[data-results-container][data-product-count]');
    }

    if (!resultsContainer && root && typeof root.closest === 'function') {
      var section = root.closest('.shopify-section');

      if (section) {
        resultsContainer = section.querySelector('[data-results-container][data-product-count]');
      }
    }

    if (!resultsContainer) {
      resultsContainer = document.querySelector('[data-results-container][data-product-count]');
    }

    if (resultsContainer) {
      count = parseInt(resultsContainer.getAttribute('data-product-count'), 10);
    }

    return isNaN(count) ? null : count;
  }

  function getLanguageString(key, fallback) {
    var language = window.Theme && window.Theme.language;

    if (language && typeof language[key] === 'string' && language[key] !== '') {
      return language[key];
    }

    return fallback;
  }

  function formatLanguageCount(oneKey, otherKey, count, fallbackOne, fallbackOther) {
    var template;

    if (count === null) {
      return '';
    }

    template = count === 1 ?
      getLanguageString(oneKey, fallbackOne) :
      getLanguageString(otherKey, fallbackOther);

    return String(template).replace(/\[\[count\]\]/g, count);
  }

  function formatResultCount(count) {
    return formatLanguageCount(
      'collection_search_result_count_one',
      'collection_search_result_count_other',
      count,
      '[[count]] tulos',
      '[[count]] tulosta'
    );
  }

  function updateClearButton(root) {
    var parts = getParts(root);

    if (parts.clear && parts.input) {
      parts.clear.hidden = parts.input.value.trim() === '';
    }
  }

  function findCollectionInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (!instances || !window.bcStaticCollection) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticCollection) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function getCurrentUrlTerm() {
    var helpers = getScopedSearchHelpers();
    var query = new URLSearchParams(window.location.search).get('q') || '';

    if (helpers) {
      return helpers.extractTerm(query);
    }

    return decodeSearchTerm(query);
  }

  function syncInputFromUrl(root) {
    var parts = getParts(root);

    if (!parts.input) {
      return '';
    }

    parts.input.value = getCurrentUrlTerm();
    updateClearButton(root);

    return parts.input.value;
  }

  function runEmbeddedSearch(root, options) {
    var parts = getParts(root);
    var instance = findCollectionInstance();
    var term = parts.input ? parts.input.value.trim() : '';
    var allowRedirect = Boolean(options && options.allowRedirect);

    updateClearButton(root);

    if (!instance || typeof instance._fetchResults !== 'function') {
      if (!term) {
        updateStatus(root, '');
        return;
      }

      if (allowRedirect) {
        updateStatus(root, getLanguageString('collection_search_redirecting', 'Siirrytään hakuun...'));
        window.location.assign(getSearchUrl(term));
      }
      return;
    }

    if (term) {
      instance.queryParams.q = encodeSearchTerm(term);
      updateStatus(root, getLanguageString('collection_search_loading', 'Haetaan tuotteita...'));
    } else {
      delete instance.queryParams.q;
      updateStatus(root, '');
    }

    instance.queryParams.page = 1;
    instance._fetchResults(false);
  }

  function syncUi(root, options) {
    var parts = getParts(root);
    var draftTerm = parts.input ? parts.input.value.trim() : '';
    var activeTerm = getCurrentUrlTerm();
    var isDirty = draftTerm !== activeTerm;

    updateClearButton(root);

    if (options && Object.prototype.hasOwnProperty.call(options, 'status')) {
      updateStatus(root, options.status);
      return;
    }

    if (isDirty) {
      updateStatus(root, '');
      return;
    }

    if (activeTerm) {
      updateStatus(root, formatResultCount(getResultCount(root)));
    } else {
      updateStatus(root, '');
    }
  }

  function submitSearch(root) {
    var parts = getParts(root);
    var term = parts.input ? parts.input.value.trim() : '';

    updateClearButton(root);
    clearQueuedAutoSearch(root);
    hidePredictiveSearch(root);

    if (!term) {
      updateStatus(root, getLanguageString('collection_search_type_prompt', 'Kirjoita hakusana hakeaksesi.'));
      return;
    }

    runEmbeddedSearch(root, { allowRedirect: true });
  }

  function clearSearch(root) {
    var parts = getParts(root);

    if (parts.input) {
      parts.input.value = '';
      parts.input.focus();
    }

    clearQueuedAutoSearch(root);
    hidePredictiveSearch(root);
    runEmbeddedSearch(root);
  }

  function handleCollectionSearchInput(root) {
    syncUi(root);
    hidePredictiveSearch(root);
    queueAutoSearch(root);
  }

  function initCollectionSearch(root) {
    var parts = getParts(root);
    var hydrated = false;

    if (
      root &&
      root.closest &&
      root.closest('[data-kk-headless-collection]') &&
      window.KKHeadlessCollection &&
      window.KKHeadlessCollection.enabled &&
      window.KKHeadlessCollection.storefrontToken
    ) {
      return;
    }

    if (!parts.input) {
      return;
    }

    if (root.dataset.kkCollectionSearchReady === 'true') {
      syncInputFromUrl(root);
      syncUi(root);
      return;
    }

    root.dataset.kkCollectionSearchReady = 'true';
    syncInputFromUrl(root);
    syncUi(root);

    parts.input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        clearQueuedAutoSearch(root);
        submitSearch(root);
      } else if (event.key === 'Escape') {
        hidePredictiveSearch(root);
      }
    });

    if (parts.submit) {
      parts.submit.addEventListener('click', function () {
        clearQueuedAutoSearch(root);
        submitSearch(root);
      });
    }

    if (parts.clear) {
      parts.clear.addEventListener('click', function () {
        clearSearch(root);
      });
    }

    function hydrateFromUrl(attempt) {
      var termFromUrl = syncInputFromUrl(root);
      var instance = findCollectionInstance();

      if (instance && !termFromUrl && instance.queryParams && instance.queryParams.q) {
        delete instance.queryParams.q;
        hydrated = false;
        runEmbeddedSearch(root);
        return;
      }

      if (!hydrated && termFromUrl && instance) {
        hydrated = true;
        runEmbeddedSearch(root);
      } else if (!hydrated && termFromUrl && (attempt || 0) < 20) {
        window.setTimeout(function () {
          hydrateFromUrl((attempt || 0) + 1);
        }, 150);
      }
    }

    window.setTimeout(function () {
      hydrateFromUrl(0);
    }, 150);
    window.addEventListener('popstate', function () {
      hydrated = false;
      hydrateFromUrl(0);
    });

    document.addEventListener('kk:collection-search-complete', function (event) {
      if (event && event.detail && !isNaN(parseInt(event.detail.resultCount, 10))) {
        root.dataset.kkCollectionSearchCount = String(parseInt(event.detail.resultCount, 10));
      }

      syncUi(root);
    });

    document.addEventListener('kk:collection-search-error', function () {
      updateStatus(root, getLanguageString('collection_search_error', 'Search failed.'));
    });
  }

  function initAllCollectionSearches() {
    document.querySelectorAll('[data-kk-collection-search]').forEach(initCollectionSearch);
  }

  document.addEventListener('input', function (event) {
    var input = event.target && event.target.closest ?
      event.target.closest('[data-kk-collection-search-input]') :
      null;
    var root = input && input.closest ?
      input.closest('[data-kk-collection-search]') :
      null;

    if (
      root &&
      !(
        root.closest &&
        root.closest('[data-kk-headless-collection]') &&
        window.KKHeadlessCollection &&
        window.KKHeadlessCollection.enabled &&
        window.KKHeadlessCollection.storefrontToken
      )
    ) {
      handleCollectionSearchInput(root);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCollectionSearches);
  } else {
    initAllCollectionSearches();
  }
}());

(function () {
  var SEARCH_VIEW_STORAGE_KEY = 'kk-search-view';
  var viewApplyTimer = null;

  function isMobileSearchLayout() {
    return window.matchMedia ?
      window.matchMedia('(max-width: 859px)').matches :
      window.innerWidth < 860;
  }

  function isSearchSectionElement(element) {
    return Boolean(element && element.closest && element.closest('.search--section'));
  }

  function getSearchOuter(element) {
    if (!isSearchSectionElement(element)) {
      return null;
    }

    return element.closest('.productgrid--outer');
  }

  function normalizeView(view) {
    return view === 'list-view' ? 'list-view' : 'grid-view';
  }

  function getStoredView() {
    return 'grid-view';
  }

  function setStoredView() {}

  function applySearchView(root, view) {
    var normalizedView = normalizeView(view);

    if (!root || !isSearchSectionElement(root)) {
      return;
    }

    root.classList.remove('productgrid-gridview', 'productgrid-listview');
    root.classList.add(normalizedView === 'list-view' ? 'productgrid-listview' : 'productgrid-gridview');

    root.querySelectorAll('[data-collection-view]').forEach(function (button) {
      button.classList.toggle(
        'active',
        button.getAttribute('data-collection-view') === normalizedView
      );
    });
  }

  function applyAllSearchViews() {
    var view = getStoredView();

    document.querySelectorAll('.search--section .productgrid--outer').forEach(function (root) {
      applySearchView(root, view);
    });
  }

  function queueApplyAllSearchViews() {
    window.clearTimeout(viewApplyTimer);
    viewApplyTimer = window.setTimeout(applyAllSearchViews, 30);
  }

  function findSearchInstance() {
    var instances = window.bcSections && window.bcSections.instances;
    var found = null;

    if (!instances || !window.bcStaticSearch) {
      return null;
    }

    Object.keys(instances).some(function (key) {
      var instance = instances[key];

      if (instance instanceof window.bcStaticSearch) {
        found = instance;
        return true;
      }

      return false;
    });

    return found;
  }

  function buildSearchUrl(updater) {
    var url = new URL(window.location.href);

    if (typeof updater === 'function') {
      updater(url.searchParams);
    }

    url.searchParams.delete('page');

    return url.pathname + (url.search ? url.search : '');
  }

  document.addEventListener('click', function (event) {
    var viewButton = event.target.closest('[data-collection-view]');

    if (viewButton && isSearchSectionElement(viewButton)) {
      var view = normalizeView(viewButton.getAttribute('data-collection-view'));

      event.preventDefault();
      setStoredView(view);
      applySearchView(getSearchOuter(viewButton), view);
    }
  }, true);

  document.addEventListener('change', function (event) {
    var sortSelect = event.target.closest('[data-productgrid-trigger-sort]');
    var instance;
    var fetchUrl;

    if (!sortSelect || !isSearchSectionElement(sortSelect)) {
      return;
    }

    fetchUrl = buildSearchUrl(function (params) {
      if (sortSelect.value) {
        params.set('sort_by', sortSelect.value);
      } else {
        params.delete('sort_by');
      }
    });

    instance = findSearchInstance();

    if (instance && typeof instance._ajaxFetch === 'function') {
      instance._ajaxFetch(fetchUrl, 1, 'change');
    } else {
      window.location.assign(fetchUrl);
    }
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(queueApplyAllSearchViews).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAllSearchViews);
  } else {
    applyAllSearchViews();
  }

  window.addEventListener('popstate', queueApplyAllSearchViews);
}());
